import 'core-js/modules/es.array.iterator.js';
import 'core-js/modules/web.dom-collections.iterator.js';
import 'core-js/modules/es.object.assign.js';
import { jsxs, jsx } from 'react/jsx-runtime';
import { Stack } from '@hub-la/design-system';
import { useFormikContext } from 'formik';
import { CnpjForm } from './cnpj-form.js';
import { CpfForm } from './cpf-form.js';
import { SelectModality } from './select-modality.js';
import { DocumentType } from '../../domain/enums/bank-account.js';

const PersonForm = () => {
  const {
    values
  } = useFormikContext();
  return jsxs(Stack, Object.assign({
    direction: "column",
    spacing: 6
  }, {
    children: [jsx(SelectModality, {}), values.businessOwner.documentType === DocumentType.CPF ? jsx(CpfForm, {}) : jsx(CnpjForm, {})]
  }));
};

export { PersonForm };
